const companyData = [
  { label: '商号', value: '株式会社 MSK' },
  {
    label: '所在地',
    value: '〒141-0031\n東京都品川区西五反田8丁目7-11 アクシス五反田ビル 7階',
    hasMap: true,
  },
  { label: '電話番号', value: '050-6877-5579' },
  { label: 'FAX番号', value: '03-6869-3539' },
  { label: '設立年月日', value: '2006年8月10日' },
  { label: '資本金', value: '1000万円' },
  {
    label: '役員',
    value: '代表取締役 春日 啓悟\n取締役 鎌田 晋也',
  },
  { label: '社員数', value: '32名（2026/4 現在）男性70％：女性30％' },
  {
    label: '取引銀行',
    value: 'みずほ銀行 新横浜支店\n城南信用金庫 営業部本店',
  },
  { label: '事業内容', value: 'コンピューターシステムの企画、開発' },
  {
    label: '認定等',
    value: 'ISO/IEC 27001:2022\n認証番号：USJ-2026-I-0214',
    hasCert: true,
  },
  { label: '許認可', value: '労働者派遣事業 許可番号：（派）13 – 318076' },
  { label: '所属団体', value: '東京商工会議所' },
  { label: '所属組合', value: '関東ITソフトウェア健康保険組合' },
  {
    label: 'IT導入支援事業',
    value: '登録済ITツール\n・ECサイト',
  },
];

const CompanyInfo = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="bg-white rounded-2xl shadow-[0_4px_24px_rgba(137,181,107,0.08)] overflow-hidden">
          {companyData.map((item, index) => (
            <div
              key={index}
              className={`flex flex-col md:flex-row ${
                index !== companyData.length - 1 ? 'border-b border-gray-100' : ''
              }`}
            >
              <div className="md:w-[200px] flex-shrink-0 bg-[#F8FBF6] px-6 py-5 flex items-start">
                <span className="text-[13px] font-bold text-[#89B56B]">{item.label}</span>
              </div>
              <div className="flex-1 px-6 py-5">
                {item.value.split('\n').map((line, i) => (
                  <p key={i} className="text-[13px] text-gray-700 leading-relaxed">
                    {line}
                    {item.hasMap && i === 0 && (
                      <a
                        href="https://maps.google.com/?q=東京都品川区西五反田8丁目7-11+アクシス五反田ビル+7階"
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                        className="ml-2 text-[#5DAA68] hover:text-[#3F6844] transition-colors text-xs font-medium cursor-pointer"
                      >
                        <i className="ri-map-pin-line mr-0.5"></i>MAP
                      </a>
                    )}
                  </p>
                ))}
                {item.hasCert && (
                  <div className="mt-3 flex items-center gap-4">
                    <img
                      src="/image/isoiec.jpg?v=20261030"
                      alt="ISO/IEC 27001 認証ロゴ（U.S. CERT / IAS）"
                      title="ISO/IEC 27001 認証"
                      className="w-[180px] max-w-full h-auto rounded-lg"
                    />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompanyInfo;
